<ng-template #modal_iframe>
	<div class="modal-header">
		<h4 class="modal-title pull-left">Editor</h4>
		<button type="button" class="btn btn-success btn-circle pull-right" (click)="closeEditorWithSaving()"><i
			class="fa fa-check"></i></button>
		<button type="button" style="margin-right:10px" class="btn btn-warning btn-circle pull-right" aria-label="Close"
		        (click)="closeEditorWithoutSaving()">
			<i class="fa fa-remove"></i>
		</button>

	</div>
	<div class="modal-body">
		<div class="tig-iframe">
			<!-- <div class="ibox-tools">
				<button type="button" class="btn btn-default bg-muted btn-circle"
					(click)="changeIframe(editor, 'tig-website')" title="{{'desktop'|translate}}"><i
						class="fa fa-desktop fa-shift"></i></button>
				<button type="button" class="btn btn-default bg-muted btn-circle"
					(click)="changeIframe(editor, 'tig-phone')" title="{{'mobile'|translate}}"><i
						class="fa fa-mobile"></i></button>
				<button type="button" class="btn btn-default bg-muted btn-circle"
					(click)="changeIframe(editor, 'tig-tablet')" title="{{'tablet'|translate}}"><i
						class="fa fa-tablet"></i></button>
			</div> -->
			<br />
			<div class="clear"></div>
			<!-- default is desktop width -->
			<iframe id="{{getIFrameID()}}" #editor width="100%" height="90%" frameborder="0" allowfullscreen
			        [srcdoc]="iframe_content"></iframe>
		</div>
	</div>
</ng-template>

<div class="form-group" [formGroup]="OBJ_form_group" [ngClass]="{'has-error': isInvalid()}">
	<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
		<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
	<div class="col-lg-8">
		<textarea class="form-control" [(ngModel)]="OBJ_field_config.value" [placeholder]="getLabelName()|translate"
		          [readonly]="OBJ_field_config?.readonly" [formControlName]="OBJ_field_config.name">
            </textarea>
		<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
	</div>
	<button type="button" #btn id="{{btn_id}}" class="btn btn-info btn-circle" (click)="openEditor(btn)"
	        title="editor"><i class="fa fa-pencil-square-o"></i></button>
</div>

<div class="form-group" *ngIf="route_to_self">
	<div class="col-lg-2 control-label"></div>
	<div class="col-lg-8">
		<a href="{{route_to_self}}" target="_blank">Vorschau anzeigen (Previewserver)</a>
	</div>
</div>
